import * as vp from 'vopay';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '';

export default vp.VoPayApi(apiBaseUrl);
